import { createStyles, makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => createStyles({
  root: {
    maxWidth: 310,
    background: '#F9FAFB',
    padding: '16px 8px 12px',
  },
  header: {
    color: '#26325F',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 5,
  },
  description: {
    fontFamily: '"Roboto", "Regular"',
    fontSize: 12,
    color: '#515B6A',
    marginBottom: 8,
  },
  lineBreak: {
    border: 'none',
    color: '#DCDEE5',
    backgroundColor: '#DCDEE5',
    height: 1,
  },
  blockTitle: {
    marginTop: 16,
    color: '#2A384F',
    fontFamily: 'Roboto',
  },
  blockDescription: {
    ontFamily: '"Roboto", "Regular"',
    fontSize: 12,
    color: '#5B6576',
    marginBottom: 16,
  },
  blockValue: {
    color: '#2A384F',
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
  footer: {
    color: '#2A384F',
    fontFamily: '"Roboto", "Medium"',
    fontSize: 16,
    fontWeight: 500,
  },
}), { name: 'VideoEditOrderCheck' });

export default useStyles;
